import { BaseBetslipGroupPick } from '../../../../../core/picks/betslip-group-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2Pick } from '../../../../../core/picks/betslip-v2-pick';
import { BaseComboPrevention, IComboPreventionValidator } from './combo-prevention';
import { ComboPreventionResult } from './combo-prevention-result.enum';

/**
 * Validate grouped picks with v1 picks (ensuring different events)
 */
class GroupedPicksV1SportComboPrevention extends BaseComboPrevention<BaseBetslipGroupPick, BetslipV1Pick> {
    constructor() {
        super(BaseBetslipGroupPick, BetslipV1Pick);
    }

    validate(thisPick: BaseBetslipGroupPick, otherPick: BetslipV1Pick): ComboPreventionResult {
        const eventId = thisPick.tryGetEventId;
        if (!!eventId && otherPick.event.id === eventId) {
            return ComboPreventionResult.NoComboAllowed;
        }

        return ComboPreventionResult.AllCombo;
    }
}

/**
 * Validate v1 picks with grouped picks (ensuring different events)
 */

class V1GroupedPicksSportComboPrevention extends BaseComboPrevention<BetslipV1Pick, BaseBetslipGroupPick> {
    constructor() {
        super(BetslipV1Pick, BaseBetslipGroupPick);
    }

    validate(thisPick: BetslipV1Pick, otherPick: BaseBetslipGroupPick): ComboPreventionResult {
        const eventId = otherPick.tryGetEventId;
        if (!!eventId && thisPick.event.id === eventId) {
            return ComboPreventionResult.NoComboAllowed;
        }

        return ComboPreventionResult.AllCombo;
    }
}

/**
 * Validate grouped picks with v2 picks (ensuring different fixtures)
 */

class GroupedPicksV2SportComboPrevention extends BaseComboPrevention<BaseBetslipGroupPick, BetslipV2Pick> {
    constructor() {
        super(BaseBetslipGroupPick, BetslipV2Pick);
    }

    validate(thisPick: BaseBetslipGroupPick, otherPick: BetslipV2Pick): ComboPreventionResult {
        const fixtureId = thisPick.tryGetFixtureId;
        if (!!fixtureId && otherPick.fixture.fixtureId === fixtureId) {
            return ComboPreventionResult.NoComboAllowed;
        }

        return ComboPreventionResult.AllCombo;
    }
}
/**
 * Validate v2 picks with grouped picks (ensuring different fixtures)
 */

class V2GroupedPicksSportComboPrevention extends BaseComboPrevention<BetslipV2Pick, BaseBetslipGroupPick> {
    constructor() {
        super(BetslipV2Pick, BaseBetslipGroupPick);
    }

    validate(thisPick: BetslipV2Pick, otherPick: BaseBetslipGroupPick): ComboPreventionResult {
        const fixtureId = otherPick.tryGetFixtureId;
        if (!!fixtureId && thisPick.fixture.fixtureId === fixtureId) {
            return ComboPreventionResult.NoComboAllowed;
        }

        return ComboPreventionResult.AllCombo;
    }
}

export const GetGroupedPicksValidators: () => IComboPreventionValidator[] = () => [
    new GroupedPicksV1SportComboPrevention(),
    new V1GroupedPicksSportComboPrevention(),
    new GroupedPicksV2SportComboPrevention(),
    new V2GroupedPicksSportComboPrevention(),
];
